ProspectValidator.$inject = ['validator'];

export default function ProspectValidator(validator) {
    const instance = new validator();

    return instance;
}
